import React from "react";
import { ReactComponent as ArrowUpIcon } from "./../../images/svg/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "./../../images/svg/arrowDown.svg";
import { gettext } from "../../adapter";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";

const ListHead = () => {
  const { search } = useLocation();
  const history = useHistory();

  const onClick = (sortProperty) => {
    let query = queryString.parse(search);
    var direction = "ASC";

    if (sortProperty !== "") {
      var oldSortProperty = query.sort;
      query.sort = sortProperty;

      if (!query.direction) {
        if (sortProperty === "name") {
          query.direction = "DESC";
        } else {
          query.direction = direction;
        }
      } else {
        if (query.direction === "ASC" && sortProperty === oldSortProperty) {
          direction = "DESC";
        }

        query.direction = direction;
      }
    } else {
      delete query.sort;
      delete query.direction;
    }

    history.push("?" + queryString.stringify(query));
  };

  let { sort, direction } = queryString.parse(search);
  if (!sort) sort = "name";
  if (!direction) direction = "ASC";

  var directionIcon = <ArrowUpIcon className="is-sorting" />;

  if (direction === "ASC") {
    directionIcon = <ArrowDownIcon className="is-sorting" />;
  }
  return (
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th colSpan="2">{gettext("Precipitation")}</th>
        <th>{gettext("Soil moisture")}</th>
        <th colSpan="3">{gettext("Refill capacity")}</th>
      </tr>
      <tr>
        <th>
          <button className="link" onClick={onClick.bind(null, "name")}>
            {gettext("Name")}
          </button>{" "}
          {sort === "name" ? directionIcon : ""}
        </th>
        <th>{gettext("T-1")}</th>
        <th>
          <button className="link" onClick={onClick.bind(null, "precipitationSumToday")}>
            {gettext("Today")}
          </button>{" "}
          {sort === "precipitationSumToday" ? directionIcon : ""}
        </th>
        <th>
          <button className="link" onClick={onClick.bind(null, "soilMoisture")}>
            {gettext("Available")}
          </button>{" "}
          {sort === "soilMoisture" ? directionIcon : ""}
        </th>
        <th>
          <button className="link" onClick={onClick.bind(null, "refillCapacity")}>
            {gettext("Today")}
          </button>{" "}
          {sort === "refillCapacity" ? directionIcon : ""}
        </th>
        <th>{gettext("T+1")}</th>
        <th>{gettext("T+2")}</th>
      </tr>
    </thead>
  );
};

export default ListHead;
